// @ts-nocheck
import action from 'utils/actionCreators';

export const GET_ASSETS_REQUEST = 'FILE_MANAGER/GET_ASSETS_REQUEST';
export const GET_ASSETS_SUCCESS = 'FILE_MANAGER/GET_ASSETS_SUCCESS';
export const GET_ASSETS_FAILURE = 'FILE_MANAGER/GET_ASSETS_FAILURE';

export const GET_ASSET_BY_ID_REQUEST = 'FILE_MANAGER/GET_ASSET_BY_ID_REQUEST';
export const GET_ASSET_BY_ID_SUCCESS = 'FILE_MANAGER/GET_ASSET_BY_ID_SUCCESS';
export const GET_ASSET_BY_ID_FAILURE = 'FILE_MANAGER/GET_ASSET_BY_ID_FAILURE';

export const ADD_ASSETS_REQUEST = 'FILE_MANAGER/ADD_ASSETS_REQUEST';
export const ADD_ASSETS_SUCCESS = 'FILE_MANAGER/ADD_ASSETS_SUCCESS';
export const ADD_ASSETS_FAILURE = 'FILE_MANAGER/ADD_ASSETS_FAILURE';

export const DELETE_ASSET_REQUEST = 'FILE_MANAGER/DELETE_ASSET_REQUEST';
export const DELETE_ASSET_SUCCESS = 'FILE_MANAGER/DELETE_ASSET_SUCCESS';
export const DELETE_ASSET_FAILURE = 'FILE_MANAGER/DELETE_ASSET_FAILURE';

export const EDIT_ASSET = 'FILE_MANAGER/EDIT_ASSET';

export const UPDATE_ASSET_REQUEST = 'FILE_MANAGER/UPDATE_ASSET_REQUEST';
export const UPDATE_ASSET_SUCCESS = 'FILE_MANAGER/UPDATE_ASSET_SUCCESS';
export const UPDATE_ASSET_FAILURE = 'FILE_MANAGER/UPDATE_ASSET_FAILURE';

export const GET_TAGS_REQUEST = 'FILE_MANAGER/GET_TAGS_REQUEST';
export const GET_TAGS_SUCCESS = 'FILE_MANAGER/GET_TAGS_SUCCESS';
export const GET_TAGS_FAILURE = 'FILE_MANAGER/GET_TAGS_FAILURE';

export const OPEN_FORM_MODAL = 'FILE_MANAGER/OPEN_FORM_MODAL';
export const CLOSE_FORM_MODAL = 'FILE_MANAGER/CLOSE_FORM_MODAL';
export const OPEN_TAG_MODAL = 'FILE_MANAGER/OPEN_TAG_MODAL';
export const OPEN_CONFIRMATION_MODAL = 'FILE_MANAGER/OPEN_CONFIRMATION_MODAL';
export const CLOSE_CONFIRMATION_MODAL = 'FILE_MANAGER/CLOSE_CONFIRMATION_MODAL';
export const UPDATE_FORM_FIELD = 'FILE_MANAGER/UPDATE_FORM_FIELD';
export const UPDATE_SEARCH_TEXT = 'FILE_MANAGER/UPDATE_SEARCH_TEXT';
export const getAssetsRequest = action(GET_ASSETS_REQUEST, 'payload');
export const getAssetByIdRequest = action(GET_ASSET_BY_ID_REQUEST, 'payload');
export const addAssetsRequest = action(ADD_ASSETS_REQUEST, 'payload');
export const deleteAssetRequest = action(DELETE_ASSET_REQUEST, 'payload');
export const editAsset = action(EDIT_ASSET, 'payload');
export const updateAssetRequest = action(UPDATE_ASSET_REQUEST, 'payload');
export const getTagsRequest = action(GET_TAGS_REQUEST, 'payload');

export const openFormModal = action(OPEN_FORM_MODAL, 'payload');
export const closeFormModal = action(CLOSE_FORM_MODAL);
export const openTagModal = action(OPEN_TAG_MODAL, 'payload');
export const openConfirmationModal = action(OPEN_CONFIRMATION_MODAL, 'payload');
export const closeConfirmationModal = action(CLOSE_CONFIRMATION_MODAL);
export const updateFormField = action(UPDATE_FORM_FIELD, 'payload');
export const updateSearchText = action(UPDATE_SEARCH_TEXT, 'payload');
